import React, { useEffect, useState, useContext } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es, enUS, ptBR } from 'date-fns/locale';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Grid, TextField, makeStyles } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { getStandardButtonStyles } from '../../styles/standardButtons';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from "react-toastify";
import './button.css';
import { i18n } from '../../translate/i18n';
import { AuthContext } from "../../context/Auth/AuthContext";
import { useTheme } from '@material-ui/core';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

// Options moved inside component

const useStyles = makeStyles((theme) => ({
    ...getStandardButtonStyles(theme),
    filterBtn: {
        top: '6px',
    }
}));

export const ChartsDate = () => {
    const theme = useTheme();
    const classes = useStyles();

    const options = {
        responsive: true,
        layout: {
            padding: {
                top: 30
            }
        },
        scales: {
            x: {
                ticks: {
                    color: theme.palette.type === 'dark' ? "#FFF" : "#000",
                },
                grid: {
                    color: theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)",
                }
            },
            y: {
                ticks: {
                    color: theme.palette.type === 'dark' ? "#FFF" : "#000",
                },
                grid: {
                    color: theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)",
                }
            }
        },
        plugins: {
            legend: {
                position: 'top',
                display: false,
            },
            title: {
                display: true,
                text: i18n.t("dashboard.charts.perDay.title"),
                position: 'left',
                color: theme.palette.type === 'dark' ? "#FFF" : "#000",
            },
            datalabels: {
                display: function(context) {
                    return context.dataset.data.length <= 15;
                },
                anchor: 'end',
                align: "top",
                offset: 5,
                color: theme.palette.primary.main,
                font: {
                    size: 14,
                    weight: "bold"
                },
            }
        },
    };
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    useEffect(() => {
        if (companyId) {
            handleGetTicketsInformation();
        }
    }, [companyId]);

    const dataCharts = {

        labels: ticketsData && ticketsData?.data.length > 0 && ticketsData?.data.map((item) => (item.hasOwnProperty('horario') ? i18n.t("dashboard.charts.fromTo", { start: item.horario, end: item.horario }) : item.data)),
        datasets: [
            {
                // label: 'Dataset 1',
                data: ticketsData?.data.length > 0 && ticketsData?.data.map((item, index) => {
                    return item.total
                }),
                backgroundColor: `${theme.palette.primary.main}99`,
                borderColor: theme.palette.primary.main,
                borderWidth: 2,
                borderRadius: 8,
                maxBarThickness: 25,
            },
        ],
    };

    const handleGetTicketsInformation = async () => {
        try {
            const { data } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);
            setTicketsData(data);
        } catch (error) {
            toast.error(i18n.t("dashboard.error.fetchTickets"));
        }
    }

    return (
        <>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
                {i18n.t("dashboard.users.totalAttendances")} ({ticketsData?.count})
            </Typography>

            <Grid container spacing={2} justifyContent="flex-end" alignItems="center" style={{ padding: '0 20px 20px 0' }}>
                <Grid item>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === 'pt' ? ptBR : i18n.language === 'es' ? es : enUS}>
                        <DatePicker
                            value={initialDate}
                            onChange={(newValue) => setInitialDate(newValue)}
                            label={i18n.t("dashboard.date.initialDate")}
                            renderInput={(params) => <TextField {...params} variant="outlined" sx={{ width: 150 }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === 'pt' ? ptBR : i18n.language === 'es' ? es : enUS}>
                        <DatePicker
                            value={finalDate}
                            onChange={(newValue) => setFinalDate(newValue)}
                            label={i18n.t("dashboard.date.finalDate")}
                            renderInput={(params) => <TextField {...params} variant="outlined" sx={{ width: 150 }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item>
                    <Button size="small" variant="outlined" className={`${classes.applyButton} ${classes.filterBtn}`} startIcon={<FilterListIcon style={{ fontSize: 18 }} />} onClick={handleGetTicketsInformation}>{i18n.t("dashboard.cards.filterButton")}</Button>
                </Grid>
            </Grid>
            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px', }} />
        </>
    );
}
